import cx from 'clsx';
import * as React from 'react';

import { AnimationEffectType, TileAnimationDataType } from '@/types/gameTypes';

import styles from './GameTile.module.scss';

interface GameTileProps {
  children: React.ReactNode;
  attachAnimationStyles?: TileAnimationDataType;
}

const getAnimationStyle = (animation?: AnimationEffectType): string =>
  animation ? styles[animation] : '';

const GameTile = (props: GameTileProps) => {
  const { attachAnimationStyles, ...restOfProps } = props;

  return (
    <div
      className={cx([
        styles.container,
        getAnimationStyle(attachAnimationStyles?.animationType),
      ])}
      {...restOfProps}
    >
      {props.children}
    </div>
  );
};

export default GameTile;
